import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import validator from 'validator';
import SinglePicker from '../common/controls/singlePicker';
import SingleOtherPicker from '../common/controls/singleOtherPicker';
import NumberInput from '../common/controls/numberInput';
import { removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
import Icon from '../common/containers/icon';
const confirmOnRemoveFields = ['assetMaintenanceDescriptionID', 'assetMaintenanceDescriptionOther', 'assetMaintenanceTypeID', 'assetMaintenanceTypeOther', 'frequency', 'assetMaintenanceFrequencyUnitID'];
const AssetMaintenanceItem = _ref => {
  let onRemove = _ref.onRemove,
    index = _ref.index,
    _ref$maintenance = _ref.maintenance,
    maintenance = _ref$maintenance === void 0 ? {} : _ref$maintenance,
    onChange = _ref.onChange,
    assetMaintenanceDescriptionList = _ref.assetMaintenanceDescriptionList,
    assetMaintenanceTypeList = _ref.assetMaintenanceTypeList,
    assetMaintenanceFrequencyUnitList = _ref.assetMaintenanceFrequencyUnitList;
  const handleRemove = () => removeItemWithConfirm(maintenance, 'Maintenance Item', confirmOnRemoveFields, onRemove.bind(null, index));
  const handleChange = (name, value) => onChange("maintenance[".concat(index, "]/").concat(name), value);
  const handleChangeOther = (field, value) => {
    let valueID = null;
    let valueOther = null;
    if (value !== null) {
      if (validator.isUUID(value)) {
        valueID = value;
      } else {
        valueOther = value;
      }
    }
    handleChange("".concat(field, "ID"), valueID);
    handleChange("".concat(field, "Other"), valueOther);
  };
  const handleChangeDescription = value => handleChangeOther('assetMaintenanceDescription', value);
  const handleChangeType = value => handleChangeOther('assetMaintenanceType', value);
  const handleChangeFrequency = value => handleChange('frequency', value);
  const handleChangeAssetMaintenanceFrequencyUnitID = value => handleChange('assetMaintenanceFrequencyUnitID', value);
  return /*#__PURE__*/React.createElement("section", {
    className: "t-ami-".concat(index)
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "form-control t-am-remove-maintenance tqc-control",
    onClick: handleRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Maintenance"))), /*#__PURE__*/React.createElement(SingleOtherPicker, {
    label: "Description",
    labelKey: "name",
    onChange: handleChangeDescription,
    options: assetMaintenanceDescriptionList,
    placeholder: "Select or type to add other...",
    value: maintenance.assetMaintenanceDescriptionOther || maintenance.assetMaintenanceDescriptionID,
    returnValueKey: "id"
  }), /*#__PURE__*/React.createElement(SingleOtherPicker, {
    label: "Type",
    labelKey: "name",
    onChange: handleChangeType,
    options: assetMaintenanceTypeList,
    placeholder: "Select or type to add other...",
    value: maintenance.assetMaintenanceTypeID || maintenance.assetMaintenanceTypeOther,
    returnValueKey: "id"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "Frequency",
    value: maintenance.frequency,
    entity: "AssetMaintenance",
    field: "frequency",
    onChange: handleChangeFrequency
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Unit of Measure",
    labelKey: "name",
    onChange: handleChangeAssetMaintenanceFrequencyUnitID,
    options: assetMaintenanceFrequencyUnitList,
    value: maintenance.assetMaintenanceFrequencyUnitID,
    returnValueKey: "id"
  }))), /*#__PURE__*/React.createElement("hr", null));
};
AssetMaintenanceItem.propTypes = {
  maintenance: PropTypes.shape({
    assetMaintenanceDescriptionOther: PropTypes.string,
    assetMaintenanceDescriptionID: PropTypes.string,
    assetMaintenanceTypeOther: PropTypes.string,
    assetMaintenanceTypeID: PropTypes.string,
    assetMaintenanceFrequencyUnitID: PropTypes.string,
    frequency: PropTypes.number
  }),
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  assetMaintenanceDescriptionList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assetMaintenanceTypeList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assetMaintenanceFrequencyUnitList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default AssetMaintenanceItem;